import { formatearMontoGasto } from '../../utils/gastos'

function VentasCobrosGastos({ datos }) {
  const montoMaximo = Math.max(
    0,
    ...datos.flatMap((mes) => [
      mes.ventasPos,
      mes.cobrado,
      mes.gastosPagados,
    ])
  )

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-bold text-slate-900">
            Ventas, cobros y gastos
          </h3>

          <p className="mt-1 text-sm text-slate-500">
            Últimos {datos.length}{' '}
            {datos.length === 1 ? 'mes' : 'meses'}.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4 text-xs font-semibold text-slate-500">
          <span className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-500" />
            Ventas POS
          </span>

          <span className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-sky-500" />
            Cobrado
          </span>

          <span className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-slate-400" />
            Gastos pagados
          </span>
        </div>
      </div>

      <div className="mt-6 overflow-x-auto">
        <div className="flex h-56 min-w-[560px] items-end gap-4 sm:gap-6">
          {datos.map((mes) => {
            const porcentajeVentasPos =
              montoMaximo > 0
                ? (mes.ventasPos / montoMaximo) * 100
                : 0

            const porcentajeCobrado =
              montoMaximo > 0
                ? (mes.cobrado / montoMaximo) * 100
                : 0

            const porcentajeGastosPagados =
              montoMaximo > 0
                ? (mes.gastosPagados / montoMaximo) * 100
                : 0

            return (
              <div
                key={mes.clave}
                className="flex h-full flex-1 flex-col items-center justify-end gap-2"
              >
                <div className="flex w-full flex-1 items-end justify-center gap-1.5">
                  <div
                    title={`Ventas POS ${
                      mes.etiqueta
                    }: ${formatearMontoGasto(mes.ventasPos)}`}
                    className="w-3 rounded-t-md bg-emerald-500 sm:w-3.5"
                    style={{ height: `${porcentajeVentasPos}%` }}
                  />

                  <div
                    title={`Cobrado ${
                      mes.etiqueta
                    }: ${formatearMontoGasto(mes.cobrado)}`}
                    className="w-3 rounded-t-md bg-sky-500 sm:w-3.5"
                    style={{ height: `${porcentajeCobrado}%` }}
                  />

                  <div
                    title={`Gastos pagados ${
                      mes.etiqueta
                    }: ${formatearMontoGasto(mes.gastosPagados)}`}
                    className="w-3 rounded-t-md bg-slate-400 sm:w-3.5"
                    style={{
                      height: `${porcentajeGastosPagados}%`,
                    }}
                  />
                </div>

                <span className="text-xs font-semibold text-slate-700">
                  {mes.etiqueta}
                </span>
              </div>
            )
          })}
        </div>
      </div>

      <div className="mt-6 border-t border-slate-100 pt-4">
        <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
          Flujo neto por mes
        </p>

        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {datos.map((mes) => {
            const color =
              mes.flujoNeto > 0
                ? 'text-emerald-600'
                : mes.flujoNeto < 0
                  ? 'text-red-600'
                  : 'text-slate-500'

            const signo = mes.flujoNeto > 0 ? '+' : ''

            return (
              <span
                key={mes.clave}
                className="font-semibold text-slate-500"
              >
                {mes.etiqueta}{' '}
                <span className={color}>
                  {signo}
                  {formatearMontoGasto(mes.flujoNeto)}
                </span>
              </span>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default VentasCobrosGastos
